import {
    Directive,
    ElementRef,
    HostBinding,
    input,
    OnDestroy,
    OnInit,
    inject
} from '@angular/core';
import { AixPendingFieldsManagerService } from '../../services/pending-fields-manager.service';
import { AbstractControl } from '@angular/forms';
import { v4 as uuid } from 'uuid';

export interface NextPendingField {
    control: AbstractControl;
    margin?: number;
}

@Directive({
    selector: '[aixPendingField]',
    standalone: true
})
export class AixNextPendingFieldDirective implements OnInit, OnDestroy {
    private elem = inject(ElementRef);
    pendingFieldsManager = inject(AixPendingFieldsManagerService);

    field = input<NextPendingField | undefined>(undefined, { alias: 'aixPendingField' });
    @HostBinding('attr.aixPendingFieldId') readonly id = uuid();

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    ngOnInit() {
        setTimeout(() => {
            if (this.field()) {
                this.pendingFieldsManager.addField(this.id as string, {
                    control: (<NextPendingField>this.field()).control,
                    elem: this.elem.nativeElement,
                    margin: (<NextPendingField>this.field()).margin
                        ? <number>(<NextPendingField>this.field()).margin
                        : 0
                });
            }
        }, 0);
    }

    ngOnDestroy() {
        if (this.field()) {
            setTimeout(() => this.pendingFieldsManager.removeField(this.id as string), 0);
        }
    }
}
